<template>
  <div class="otzyvy-page small-scroll-bar small-scroll-bar--black">
    <SuReviews
      title-type="h1"
      title-text="отзывы учеников и&nbsp;родителей <br><span>со всего мира</span>"
    />

    <otzyvy-form />

    <SuFaq />

    <school-new-breadcrumbs :breadcrumbs="breadcrumbs" />
  </div>
</template>

<script>
import HeadMixin from '@/mixins/HeadMixin';

import SuReviews from '@/components/v2/school-university/SuReviews.vue';
import SuFaq from '@/components/v2/school-university/SuFaq.vue';
import OtzyvyForm from '~/components/v2/otzyvy/OtzyvyForm.vue';
import SchoolNewBreadcrumbs from '../../components/v2/school-new/SchoolNewBreadcrumbs.vue';

export default {
  name: 'OtzyvyPage',
  components: {
    SchoolNewBreadcrumbs,
    OtzyvyForm,
    SuReviews,
    SuFaq,
  },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',

  data: () => ({
    modal: false,
    breadcrumbs: [
      { text: 'главная', to: '/' },
      { text: 'отзывы', to: '/otzyvy' },
    ],

    // для head
    title: 'Отзывы родителей и учеников | Школьный Университет «Синергия»',
    // eslint-disable-next-line max-len,vue/max-len
    description: 'Хотите узнать, что думают родители и ученики о Школьном Университете «Синергия»?  Прочтите реальные отзывы и узнайте почему они выбирают нас',
    image: '/v2/otzyvy/share-image.jpg',
    headScripts: [{
      // eslint-disable-next-line max-len,vue/max-len
      src: 'https://js.onef.pro/static/reg1f_v1.js?1f_pixel_id=24aed672-c5f3-4e78-ba7e-eed74b860cd1&event_type=visit&product=new_online_school_ege',
      defer: true,
      type: 'text/javascript',
    }],
  }),
};
</script>

<style lang="scss" scoped>
.otzyvy-page {
  overflow-x: hidden;
  margin-inline: auto;
  padding-inline: calc(var(--scale) * 40);
  background-color: #ECEDF0;
  padding-block: calc(var(--scale) * 120);

  display: flex;
  flex-direction: column;
  gap: calc(var(--scale) * 128);

  @include media-down($size-tablet) {
    padding-inline: calc(var(--scale) * 16);
    padding-bottom: calc(var(--scale) * 80);
    gap: calc(var(--scale) * 76);
  }

  @include media-down($size-mobile) {
    padding-inline: calc(var(--scale) * 12);
  }

  ::v-deep(*) {
    font-family: "Onest", sans-serif;
  }
}
</style>
